import { debounce } from '../../_modules/helpers';

export function initSlider(rootClass) {
  const isMobile = /Mobi|Android/i.test(navigator.userAgent)

  const hideElem = elem => elem.setAttribute('hidden', true)
  const showElem = elem => elem.removeAttribute('hidden')

  const start = () => {

      const rootElement = document.querySelector(rootClass)
      if (rootElement === null) return;

      const customNav = rootElement.querySelector('.slider-nav')
      const isCustomNavigation = !!customNav

      const slider = rootElement.querySelector('.slider')
      const left = rootElement.querySelector('.slider__control--left')
      const right = rootElement.querySelector('.slider__control--right')
      const inner = rootElement.querySelector('.slider__inner')

      let sliderWidth
      let innerWidth
      let scrollingAmount

      const scroll = amount => {
          const before = slider.scrollLeft
          slider.scrollBy(amount, 0)
          setTimeout(() => {
              const after = slider.scrollLeft
              if (before === after) {
                  slider.classList.remove('slider--snap')
                  slider.scrollBy(amount, 0)
                  setTimeout(() => slider.classList.add('slider--snap'), 100)
              }
          }, 30)
      }

      const scrollToLeft = () => scroll(-scrollingAmount)
      const scrollToRight = () => scroll(scrollingAmount)
      const getScrollingAmount = () => Math.ceil((sliderWidth / 3) * 2)

      const manageControls = debounce(() => {
          const scrollPos = Math.floor(slider.scrollLeft + sliderWidth)
          const isBeginning = Math.abs(scrollPos - sliderWidth) < 20
          const isEnd = Math.abs(scrollPos - innerWidth) < 20

          if (!isCustomNavigation) {
              if (isEnd) hideElem(right)
              else showElem(right)

              if (isBeginning) hideElem(left)
              else showElem(left)
          }
      })

      const fillSliderParams = debounce(() => {
          sliderWidth = Math.ceil(slider.getBoundingClientRect().width)
          innerWidth = Math.ceil(inner.getBoundingClientRect().width)
          scrollingAmount = getScrollingAmount()
          const noNeedToScroll = innerWidth <= sliderWidth

          if (noNeedToScroll) {
              hideElem(left)
              hideElem(right)

              slider.removeEventListener('scroll', manageControls)
              left.removeEventListener('click', scrollToLeft)
              right.removeEventListener('click', scrollToRight)
              return
          }

          manageControls()

          slider.addEventListener('scroll', manageControls)
          left.addEventListener('click', scrollToLeft)
          right.addEventListener('click', scrollToRight)
      })

      window.addEventListener('resize', fillSliderParams)
      fillSliderParams()

      return () => {
          window.removeEventListener('resize', fillSliderParams)
          slider.removeEventListener('scroll', manageControls)
          left.removeEventListener('click', scrollToLeft)
          right.removeEventListener('click', scrollToRight)
      }
  }

  const shouldhaveButtons = CSS.supports('scroll-behavior', 'smooth') || !isMobile || document.querySelector(rootClass)
  if (shouldhaveButtons) return start()

}
